<template>
    <div class="modal fade client-message-modal" id="modal-conversation" tabindex="-1" role="dialog"
         aria-hidden="true" data-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="dismiss-modal-btn" data-dismiss="modal" aria-label="Close">
                <i class="fad fa-times-circle"></i>
            </div>
            <div class="modal-content" v-if="person">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12 mgb-3">
                            <div class="modal-heading">
                                <h1 v-if="type === 'client'"> Client: {{person.last_name}} {{person.first_name}} </h1>
                                <h1 v-else-if="type === 'agent'"> Agent Imobiliar: {{person.last_name}} {{person.first_name}} </h1>
                            </div>
                        </div>
                    </div>
                    <div class="row b-bottom">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12 mt-2">
                            <h2 class="modal-col-heading"> Mesaje </h2>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="messages-container" v-if="conversation && conversation.messages.length > 0">
                                <div v-for="(message, index) in conversation.messages"
                                     :key="index"
                                     class="single-message message-received"
                                     :class="[user.email === message.receiver_email ? 'message-received': 'message-sent']"
                                >
                                    <div class="single-message-heading">
                                        <span> {{dateHumanize(message.created_at)}} </span>
                                    </div>
                                    <div class="single-message-content">
                                        <nl2br tag="p" :text="message.body"/>
                                    </div>
                                </div>
                            </div>
                            <div class="create-message-container mgb-3">
                                <div class="input-container">
                                    <div class="input-group mg-b">
                                        <textarea v-model="messageBody" id="new_message"></textarea>
                                        <div class="input-icon">
                                            <i class="fad fa-comment-alt-lines"></i>
                                        </div>
                                        <label class="custom-label" for="new_message"> * Mesaj nou </label>
                                    </div>
                                    <p class="custom-input-error"></p>
                                </div>
                                <div class="center-content mt-3">
                                    <button type="button" name="button" class="general-btn positive-btn" @click="sendMessage">
                                        <i class="fad fa-paper-plane"></i>
                                        <span> Trimite Mesaj </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                            <div class="mt-3 d-flex justify-content-end">
                                <!-- <button type="button" class="general-btn positive-btn">
                                    <i class="fad fa-user-plus"></i>
                                    <span> Salveaza modificari </span>
                                </button> -->
                                <button type="button" class="general-btn negative-btn" @click="closeModal()">
                                    <i class="fad fa-times-circle"></i>
                                    <span> Inchide </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "MessageModal",
    components: {},
    props: ['user'],
    data() {
      return {
        person: null,
        conversation: null,
        projectId: null,
        messageBody: '',
        type: ''
      }
    },
    mounted() {
      let vm = this
      $('#modal-conversation').on('hidden.bs.modal', function () {
        vm.person = null
        vm.conversation = null
        vm.projectId = null
        vm.messageBody = ''
        vm.type = ''
      });
      this.$eventBus.$on('open-conversation', function (payLoad) {
        vm.person = payLoad.person
        vm.type = payLoad.type
        vm.projectId = payLoad.projectId ? payLoad.projectId : null
        vm.getConversation();
        $('#modal-conversation').modal('show')
      });
    },
    methods: {
      closeModal() {
        $('#modal-conversation').modal('hide')
      },
      getConversation()
      {
        let vm = this
        let projectId = this.projectId;

        window.axios.get(`/ajax/conversations/by-email/${this.person.email}/${projectId}`)
          .then(function (response) {
            vm.conversation = response.data.data;
          })
          .catch(function () {
          });
      },
      sendMessage() {
        let vm = this;
        let projectId = this.projectId;
        if (this.messageBody.length > 0) {
          window.axios.post('/ajax/conversations', {
            body: this.messageBody,
            project: (projectId) ? projectId : null,
            receiver: this.person.email,
            sender_developer: 1,
            category: this.type
          })
            .then(function (response) {
              if (vm.conversation) {
                vm.conversation.messages.push(response.data.data)
              } else {
                vm.conversation = response.data.data.conversation
              }
              vm.messageBody = ''
            })
            .catch(function () {
              window.Swal.fire({
                html: 'Oops... Ceva a mers prost. Va rugam sa incercati din nou mai tarziu.',
                icon: 'error'
              })
            });
        }
      },
    }
  }
</script>
